var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopAccordionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FBF5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 38.5C18.0625 38.5 17.4742 38.2554 16.985 37.7663C16.495 37.2763 16.25 36.6875 16.25 36C16.25 35.3125 16.495 34.7237 16.985 34.2337C17.4742 33.7446 18.0625 33.5 18.75 33.5C19.4375 33.5 20.0258 33.7446 20.515 34.2337C21.005 34.7237 21.25 35.3125 21.25 36C21.25 36.6875 21.005 37.2763 20.515 37.7663C20.0258 38.2554 19.4375 38.5 18.75 38.5ZM31.25 38.5C30.5625 38.5 29.9742 38.2554 29.485 37.7663C28.995 37.2763 28.75 36.6875 28.75 36C28.75 35.3125 28.995 34.7237 29.485 34.2337C29.9742 33.7446 30.5625 33.5 31.25 33.5C31.9375 33.5 32.5263 33.7446 33.0163 34.2337C33.5054 34.7237 33.75 35.3125 33.75 36C33.75 36.6875 33.5054 37.2763 33.0163 37.7663C32.5263 38.2554 31.9375 38.5 31.25 38.5ZM16.5 16H34.9375C35.4167 16 35.7812 16.2133 36.0312 16.64C36.2813 17.0675 36.2917 17.5 36.0625 17.9375L31.625 25.9375C31.3958 26.3542 31.0883 26.6771 30.7025 26.9062C30.3175 27.1354 29.8958 27.25 29.4375 27.25H20.125L18.75 29.75H33.75V32.25H18.75C17.8125 32.25 17.1042 31.8383 16.625 31.015C16.1458 30.1925 16.125 29.375 16.5625 28.5625L18.25 25.5L13.75 16H11.25V13.5H15.3125L16.5 16Z",
    fill: "#9E007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopAccordionIcon);
export default __webpack_public_path__ + "static/media/shop-accordion-icon.43f3182bfe91deb13c75c31671951d1c.svg";
export { ForwardRef as ReactComponent };